import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./slices/userSlice";
import { orderSlice } from "./slices/orderSlice";
import { reviewSlice } from "./slices/reviewSlice";
import { textChangeSlice } from "./slices/textSlice";
import { businessSlice } from "./slices/businessSlice";
import { dashboardSlice } from "./slices/dashbaordSlice";
import { categorySlice } from "./slices/categorySlice";
import { subCategorySlice } from "./slices/subCategorySlice";
import { bannerSlice } from "./slices/bannerSlice";
import { emojiSlice } from "./slices/emojiSlice";
import { priceSlice } from "./slices/priceSlice";

const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    order: orderSlice.reducer,
    review: reviewSlice.reducer,
    text: textChangeSlice.reducer,
    business: businessSlice.reducer,
    dashboard: dashboardSlice.reducer,
    category: categorySlice.reducer,
    subCategory: subCategorySlice.reducer,
    banner: bannerSlice.reducer,
    emoji: emojiSlice.reducer,
    price: priceSlice.reducer,
  },
});
export default store;
